import AbsComponent from '../../components/AbsComponent';
import TemplItem from './TemplItem';
import TemplSpell from './TemplSpell';
import TemplPolymorph from './TemplPolymorph';
import TemplMagicdoll from './TemplMagicdoll';
import { hasClass, copyUrl, shareUrl } from '../../common/Utils';

export default class Detail extends AbsComponent {
    constructor(_name = '', _store = {}, _actions = {}, _router = {}, _el = '') {
        super(_name, _store, _actions, _router, _el);

        this.isOpen = false;
        const loadingTmpl = `<div class="nc-community-loader" style="display:flex;position:unset;width: 100%;height:300px;justify-content:center;align-items:center;"><span class="loader-circle"></span></div>`;
        $('.swiper-wrapper').prepend(loadingTmpl);

        this.templSel = { item: TemplItem, spell: TemplSpell, polymorph: TemplPolymorph, 'magic-dolls': TemplMagicdoll };

        let watchD = this.watch(this.store.getState, 'detail', this.isEqual);
        this.store.subscribe(watchD(this.loadData.bind(this)));

        this.addEvents();
    }

    loadData(_newVal, _oldVal, _path) {
        const nowState = this.store.getState();
        const tempArr = nowState.detail.split('_');
        const { type, id, option } = { type: tempArr[0], id: tempArr[1], option: tempArr[2] };

        jQuery(this.el).toggleClass('is-active', !!nowState.detail);
        jQuery('body').css('overflow', !!nowState.detail ? 'hidden' : '');
        if (!type) return false;

        const templCon = this.templSel[type];
        let newSlide = new templCon('type', this.store, this.actions, this.router, '.swiper-wrapper .swiper-slide');
        newSlide.loadData(id, option, this.loadComp.bind(this));
        $('.gameinfo-detail__section').scrollTop(0);
    }

    loadComp(_name) {
        $('.swiper-wrapper .swiper-slide [data-detailshow]').on('click', (e) => {
            this.router.goMultiParam({ detail: e.currentTarget.dataset.detailshow });
        });

        $('.swiper-wrapper .swiper-slide .btn-folder').on('click', (e) => {
            $(e.currentTarget).toggleClass('is-active');
            $(e.currentTarget).parent().siblings('article').toggleClass('is-active');
        });

        $('.swiper-wrapper .swiper-slide .btn-favorite').on('click', (e) => {
            const isFav = $(e.currentTarget).hasClass('is-active');
            const type = e.currentTarget.dataset.info.split('_')[0];
            const id = e.currentTarget.dataset.info.split('_')[1];
            const l10n = this.store.getState().config.l10n;

            axios({
                method: isFav ? 'DELETE' : 'POST',
                url: `${this.store.getState().config.apiDomain}/webcontents/favorites/${type}/${id}`,
                withCredentials: true,
            })
                .then((_res) => {
                    $(this.el + ' .btn-favorite').toggleClass('is-active', !isFav);

                    this.store.dispatch(this.actions.setFavDetail({ id: parseInt(id), isFavorite: !isFav }));

                    ncrwd.toast({
                        id: 'gif' + Math.random().toString(36).substr(2, 9),
                        title: !isFav ? l10n['common.favoritesAdded'] : l10n['common.favoritesRemoved'],
                        site: 'lw',
                        useCancelBtn: false,
                        usePrimaryBtn: false,
                        autoClose: 2500,
                    });
                })
                .catch((error) => {
                    if (error.response?.statusText === 'Unauthorized') {
                        window.GNBLogin();
                    }
                    if (error.response?.data?.result?.error === 'EXCEEDED') {
                        window.alert(l10n['common.favoritesUpto500']);
                    }
                })
                .then((d) => {});
        });
    }

    addEvents() {
        $(this.el + ' .btn-close').on('click', (e) => this.close());
        $(document).on('keydown', (e) => {
            if (e.keyCode === 27) this.close(); // ESC
        });
        $(this.el).on('click', (e) => {
            if ($(e.target).hasClass('gameinfo-detail-wrapper is-active')) this.close();
        });

        $('.gameinfo-detail .btn-share').on('click', (e) => {
            let state = this.store.getState();
            const tempArr = this.store.getState().detail.split('_');
            const { type, id, option } = { type: tempArr[0], id: tempArr[1], option: tempArr[2] };
            const l10n = this.store.getState().config.l10n;

            axios({
                method: 'GET',
                url: `${state.config.apiDomain}/game/${type}${type !== 'magic-dolls' ? 's' : ''}/${id}`,
                withCredentials: window.isLoginFlag === 'true',
                params: { locale: state.config.locale },
            })
                .then((_res) => {
                    this.startShare({
                        _apiPath: `${this.store.getState().config.apiDomain}/game/short`,
                        _title: _res.data.name,
                        _callback: () => {
                            ncrwd.toast({
                                id: 'gif' + Math.random().toString(36).substr(2, 9),
                                title: `${l10n['price.detail.copied']}`,
                                useCancelBtn: false,
                                site: 'lw',
                                useCancelBtn: false,
                                usePrimaryBtn: false,
                                autoClose: 3000,
                            });
                        },
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        });

        $('.gameinfo-detail .btn-prev').on('click', (e) => {
            History.back();
        });
    }

    close() {
        this.router.goMultiParam({ detail: '' });
        jQuery(this.el).removeClass('is-active');
        jQuery('html').css('overflow', '');
        $('.swiper-wrapper .swiper-slide').html('');
    }

    startShare = async ({ _apiPath, _title, _callback }) => {
        try {
            const res = await axios({
                method: 'POST',
                url: _apiPath,
                data: { url: location.href },
            });

            const isMobile = hasClass(document.body, 'mobile');

            if (isMobile) {
                await shareUrl(res.data.shortened, _title);
            } else {
                await copyUrl(res.data.shortened);
                _callback();
            }
        } catch (err) {
            console.log(err);
        }
    };
} // end of class
